import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { keysToSnake } from '#/api/adapters/wireCase';

/** DELETE `/crm/cost-estimates/{id}`。body：`updatedAt`。 */
export async function deleteCostEstimate(id, payload) {
  const { data: raw } = await request.delete(`/crm/cost-estimates/${id}`, {
    data: keysToSnake(payload),
  });
  return parseVer4DetailResponse(raw);
}
